import { RouteNamesEnum } from "@service/router/RouteNamesEnum";

export const isRouteMeetings = (routeName: string) => {
    return routeName === RouteNamesEnum.viewMeeting || routeName === RouteNamesEnum.viewMeetingPublic || routeName === RouteNamesEnum.viewMeetingPublicRecording
}

export const isRouteForBackground = (routeName: string) => {
    const backgroundRoutes: string[] = [
        RouteNamesEnum.viewMeetingPublic,
        RouteNamesEnum.viewMeeting,
        RouteNamesEnum.viewSession,
        RouteNamesEnum.appointment
    ];
    return backgroundRoutes.includes(routeName);
}